import React, { useContext } from 'react';
import { getRange } from 'lib/getRange';
import { priceFormatter, sqftFormatter } from 'src/utils/utils';
import { NO_DATA_PLACEHOLDER } from 'constants/labels';
import { BuildingPageContext } from '../../../../pages/[urlParam]/[urlBuildParam]';
import { BuildingPageContextInterface } from '../../../../apolloClient/types/Building';
import GalleryPopupHeaderV2 from './GalleryPopupHeaderV2';
import { BuildingGalleryFavoriteButtonV2 } from './GalleryFavoriteButtonV2';

const BuildingGalleryPopupHeaderV2: React.FC<{
  onClose?: () => void;
  photoCounter?: string;
}> = ({ onClose, photoCounter }) => {
  const {
    building: {
      id,
      floorsCount,
      name,
      unitsCount,
      buildingStats,
      primaryAddress,
    },
    favorite,
  } = useContext(BuildingPageContext) as BuildingPageContextInterface;

  if (!buildingStats) return <div>No building stats</div>;

  const stats = [
    getRange(
      buildingStats,
      (val) => val?.minSalePrice,
      (val) => val?.maxSalePrice,
      priceFormatter
    ),
    `${getRange(
      buildingStats,
      (val) => val?.minSaleSqft,
      (val) => val?.maxSaleSqft,
      sqftFormatter
    )} sqft`,
    `${unitsCount || NO_DATA_PLACEHOLDER} units`,
    `${floorsCount || NO_DATA_PLACEHOLDER} stories`,
  ];

  return (
    <div className="relative">
      <GalleryPopupHeaderV2
        name={name}
        stats={stats}
        primaryAddress={primaryAddress}
        onClose={onClose}
        photoCounter={photoCounter}
        favoriteButton={(showLabel, useLargeIcons) => (
          <BuildingGalleryFavoriteButtonV2
            buildingId={id}
            userFavorites={favorite}
            showLabel={showLabel}
            useLargeIcons={useLargeIcons}
          />
        )}
      />
    </div>
  );
};

export default BuildingGalleryPopupHeaderV2;
